import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
export { INTENT, VALIDATION_SKIPPED, VALIDATION_UNDEFINED } from '@conform-to/dom';

/**
 * Cleanup `undefined` from the dervied props
 * To minimize conflicts when merging with user defined props
 */
function cleanup(props) {
  for (var key in props) {
    if (props[key] === undefined) {
      delete props[key];
    }
  }
  return props;
}
function getFormElementProps(config, options) {
  var _config$error, _config$error2;
  return cleanup({
    id: config.id,
    name: config.name,
    form: config.form,
    'aria-invalid': options !== null && options !== void 0 && options.ariaAttributes && config.errorId && (_config$error = config.error) !== null && _config$error !== void 0 && _config$error.length ? true : undefined,
    'aria-describedby': options !== null && options !== void 0 && options.ariaAttributes ? [config.errorId && (_config$error2 = config.error) !== null && _config$error2 !== void 0 && _config$error2.length ? config.errorId : undefined, config.descriptionId && options !== null && options !== void 0 && options.description ? config.descriptionId : undefined].reduce((result, id) => {
      if (!result) {
        return id;
      }
      if (!id) {
        return result;
      }
      return "".concat(result, " ").concat(id);
    }) : undefined
  });
}
function getFormControlProps(config, options) {
  return cleanup(_objectSpread2(_objectSpread2({}, getFormElementProps(config, options)), {}, {
    required: config.required,
    autoFocus: config.initialError && Object.entries(config.initialError).length > 0 ? true : undefined
  }, options !== null && options !== void 0 && options.hidden ? hiddenProps : undefined));
}
var hiddenProps = {
  /**
   * Style to make the input element visually hidden
   * Based on the `sr-only` class from tailwindcss
   */
  style: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0,0,0,0)',
    whiteSpace: 'nowrap',
    border: 0
  },
  tabIndex: -1,
  'aria-hidden': true
};
function input(config) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var props = _objectSpread2(_objectSpread2({}, getFormControlProps(config, options)), {}, {
    type: options.type,
    minLength: config.minLength,
    maxLength: config.maxLength,
    min: config.min,
    max: config.max,
    step: config.step,
    pattern: config.pattern,
    multiple: config.multiple
  });
  if (options.type === 'checkbox' || options.type === 'radio') {
    var _options$value;
    props.value = (_options$value = options.value) !== null && _options$value !== void 0 ? _options$value : 'on';
    props.defaultChecked = config.defaultValue === props.value;
  } else if (options.type !== 'file') {
    props.defaultValue = config.defaultValue;
  }
  return cleanup(props);
}
function select(config, options) {
  return cleanup(_objectSpread2(_objectSpread2({}, getFormControlProps(config, options)), {}, {
    defaultValue: config.defaultValue,
    multiple: config.multiple
  }));
}
function textarea(config, options) {
  return cleanup(_objectSpread2(_objectSpread2({}, getFormControlProps(config, options)), {}, {
    defaultValue: config.defaultValue,
    minLength: config.minLength,
    maxLength: config.maxLength
  }));
}
function fieldset(config, options) {
  return getFormElementProps(config, options);
}

export { fieldset, hiddenProps, input, select, textarea };
